import { DatadogEnv } from "@/types/datadog";

/** Single source of truth for Datadog identity; the Docker sourcemap upload uses the same literal. */
export const DD_SERVICE = "consumer-loan-application";

export const DD_SITE = "datadoghq.eu";

export const DD_VERSION = `1.0.0${process.env.BUILD_VER ? "-" : ""}${
	process.env.BUILD_VER ?? ""
}`;

/** Telemetry only ships from production builds outside the `local` env (`DD_ENV`). */
export const isDatadogEnv = (env: string | undefined): boolean =>
	env !== DatadogEnv.LOCAL && process.env.NODE_ENV === "production";

export const SENSITIVE_KEYS = [
	"nationalId",
	"mobileNumber",
	"emailAddress",
	"firstName",
	"lastName",
];
